import { useToast } from "@chakra-ui/react"

export const useAppToast = () => {
  return useToast({ position: "bottom-right", isClosable: true })
}
